import React from "react";
import { Box } from "@material-ui/core";
import Loader from "react-loader-spinner";

interface IProps {
  disableTimeout?: boolean;
  timeout?: number;
}

const ProfileSpinner: React.FC<IProps> = ({
  disableTimeout = false,
  timeout = 5000,
}) => {
  const timeoutProps = disableTimeout ? {} : { timeout };

  return (
    <Box pt={5} pb={5} textAlign="center">
      <Loader 
        type="Bars" 
        color="#da2232" 
        height={100} 
        width={100}
        {...timeoutProps} />
    </Box>
  );
};

export default ProfileSpinner;
